<template>
    <div id="unauth">
        <h3>No tiene permisos para acceder a la herramienta.</h3>
        <h4>Por favor contacte con un administrador.</h4>
    </div>
</template>
<script>
export default {
    name: 'unauthorized'
}
</script>
<style lang="scss" scoped>

#unauth {
    width: 100%;
    height: 30vh;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    vertical-align: middle;
}
</style>